import React from "react";
import { Link } from "react-router-dom";
import { SectionHeading } from "./SectionHeading";
import {
  FaApple,
  FaWhatsapp,
  FaEnvelope,
  FaMapMarkerAlt,
  FaChevronRight,
} from "react-icons/fa";
import { IoLogoAndroid } from "react-icons/io";
import { useTranslation } from "react-i18next";

interface FooterLinkSectionProps {
  title: string;
  links: { label: string; path: string }[];
}

const FOOTER_LINKS = {
  GBA_TAXI: [
    { label: "Home", path: "/" },
    { label: "About", path: "/" },
    { label: "Drivers Recruitment", path: "/driver" },
    { label: "Sponsored#1", path: "https://kirei-hada.com" },
    { label: "Sponsored#2", path: "https://xinics.com.hk" },
    { label: "Sponsored#3", path: "https://p360tec.com" },
    { label: "Sponsored#4", path: "https://gbataxi.com" },

    // { label: 'News Center', path: '#' }
  ],
  TRAVEL_SERVICES: [
    { label: "Cross-border Ride-hailing", path: "/cross-border" },
    { label: "Shared Ride-hailing", path: "/book" },
    { label: "Local Ride-hailing Taxi", path: "/book" },
  ],
  CONTACT_US: [
    { label: "Email", path: "#" },
    { label: "WhatsApp", path: "https://wa.me/96877871" },
    { label: "Linkedin", path: "#" },
    { label: "Address", path: "#" },
  ],
  INFORMATION: [
    { label: "FAQ", path: "#" },
    { label: "All Documents", path: "#" },
  ],
};

// Define collaborator data
const COLLABORATORS = [
  // {
  //   name: 'GBA Taxi',
  //   logo: '/image/logo/GBA_logo.png',
  //   link: '#',
  // },
  {
    name: "P360 Smartcap",
    logo: "/image/logo/p360tec_logo.jpg",
    link: "https://p360tec.com",
  },
  {
    name: "Winfo",
    logo: "/image/logo/Winfo_logo.png",
    link: "https://winfo.hk",
  },
  {
    name: "DollarPond",
    logo: "/image/logo/DollarPond_logo.jpg",
    link: "https://Dollarpond.com",
  },
  {
    name: "Moneyxpat",
    logo: "/image/logo/Moneyxpat_logo.svg",
    link: "https://moneyxpat.com",
  },
  {
    name: "Xinics",
    logo: "/image/logo/Xinics_logo.png",
    link: "https://xinics.com.hk",
  },
  {
    name: "esg-tec",
    logo: "/image/logo/esg-tec_logo.png",
    link: "https://esg-tec.com",
  },
  {
    name: "esghelps",
    logo: "/image/logo/esghelp_logo.svg",
    link: "https://esghelps.com",
  },
];

// Collaborator section component
const CollaboratorSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="">
      <SectionHeading
        size="md"
        className="text-xl font-bold text-white mb-6 pb-2 border-b border-gray-700 inline-block"
      >
        {t("collaborator_title")}
      </SectionHeading>

      <div className="max-h-[300px] overflow-y-auto pr-2 hide-scrollbar rounded-lg">
        <div className="grid grid-cols-2">
          {COLLABORATORS.map((collaborator, index) => (
            <a
              key={index}
              href={collaborator.link}
              target="_blank"
              rel="noopener noreferrer"
              className="group rounded-lg p-4 transition-all"
            >
              <div className="flex flex-col items-center">
                <div className="w-16 h-16 bg-gray-700/70 rounded-lg flex items-center justify-center p-2 overflow-hidden group-hover:shadow-md">
                  <img
                    src={collaborator.logo}
                    alt={collaborator.name}
                    className="h-full w-full object-contain"
                    onError={(e) => {
                      e.currentTarget.src = `https://placehold.co/60x60/333/fff?text=${collaborator.name.substring(
                        0,
                        2,
                      )}`;
                    }}
                  />
                </div>
                <span className="mt-3 text-sm text-gray-300 text-center group-hover:text-white transition-colors">
                  {collaborator.name}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

const FooterLinkSection: React.FC<FooterLinkSectionProps> = ({
  title,
  links,
}) => {
  const { t } = useTranslation();
  return (
    <nav className="footer-nav">
      <SectionHeading
        size="md"
        className="text-xl font-bold text-white mb-6 pb-2 border-b border-gray-700 inline-block"
      >
        {t(title)}
      </SectionHeading>
      <ul className="space-y-3">
        {links.map((link, index) => (
          <li key={index} className="group">
            <Link
              to={link.path}
              className="text-gray-300 hover:text-white transition-colors duration-300 text-sm flex items-center"
            >
              <FaChevronRight className="mr-2 text-xs opacity-0 group-hover:opacity-100 transform -translate-x-2 group-hover:translate-x-0 transition-all duration-300" />
              <span>{t(link.label)}</span>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export const AppDownloadSection: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-row items-center justify-center gap-3 sm:gap-4 md:gap-8 px-2 sm:px-4 md:px-0">
      {/* Mobile App Image */}
      <img
        className="w-1/4 sm:w-1/5 md:w-1/6 max-w-[100px] md:max-w-xs flex-shrink-0"
        src="/image/example_iPhone.png"
        alt="Mobile App"
      />

      {/* Text and QR/App Store Section */}
      <div className="flex flex-col justify-between space-y-3 md:space-y-6">
        {/* Text Section */}
        {/*<div className="text-left">*/}
        {/*  <SectionHeading size="md" className="text-sm sm:text-base md:text-lg">{t('FooterAppDownload1')}</SectionHeading>*/}
        {/*  <p className="mt-1 sm:mt-2 text-xs sm:text-sm md:text-base">{t('FooterAppDownload2')}</p>*/}
        {/*</div>*/}

        {/* QR Code and App Store Logos */}
        <div className="app-download-container relative overflow-hidden rounded-2xl bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 p-5 md:p-6 border border-gray-700/30 shadow-xl">
          {/* Decorative elements */}
          <div className="absolute top-0 right-0 w-40 h-40 bg-blue-500/10 rounded-full blur-2xl transform translate-x-10 -translate-y-10"></div>
          <div className="absolute bottom-0 left-0 w-40 h-40 bg-green-500/10 rounded-full blur-2xl transform -translate-x-10 translate-y-10"></div>

          {/* App download heading */}
          <div className="mb-5 text-center md:text-left">
            <h3 className="text-lg md:text-xl font-bold text-white mb-2">
              {t("FooterAppDownload1")}
            </h3>
            <p className="text-sm text-gray-300 max-w-md mx-auto md:mx-0">
              {t("FooterAppDownload2")}
            </p>
          </div>

          {/* App download options */}
          <div className="flex flex-col md:flex-row items-center gap-6 mt-4">
            {/* iOS Download */}
            <a
              href="https://apps.apple.com/us/app/gba-taxi/id6472980541"
              target="_blank"
              rel="noopener noreferrer"
              className="app-card group w-full md:w-1/2 flex flex-row items-center bg-gradient-to-br from-blue-900/20 to-blue-800/10 rounded-xl overflow-hidden backdrop-blur-sm border border-blue-500/20 transition-all duration-300 hover:border-blue-400/40 hover:shadow-lg hover:shadow-blue-500/10 hover:-translate-y-1"
            >
              {/* QR Code section */}
              <div className="relative p-3 bg-white/95 rounded-l-xl h-full flex items-center justify-center">
                <img
                  className="w-20 h-20 object-contain"
                  src="image/IOS QR Code 1.svg"
                  alt="Download GBA Taxi iOS App"
                />
                <div className="absolute top-2 right-2 w-6 h-6 bg-black rounded-full flex items-center justify-center">
                  <FaApple className="text-white text-xs" />
                </div>
              </div>

              {/* Text content */}
              <div className="flex flex-col p-4">
                <span className="text-xs font-medium text-blue-300">
                  APP STORE
                </span>
                <span className="text-base font-bold text-white my-1 group-hover:text-blue-200 transition-colors">
                  {t("FooterAppDownload3")}
                </span>
                <div className="flex items-center text-xs text-blue-400 mt-1">
                  <span>{t("FooterAppDownload5")}</span>
                  <FaChevronRight className="ml-1 text-[8px] transition-transform duration-300 group-hover:translate-x-1" />
                </div>
              </div>
            </a>

            {/* Android Download */}
            <a
              href="https://play.google.com/store/apps/details?id=com.gbataxi.gbataxi&hl=en-US"
              target="_blank"
              rel="noopener noreferrer"
              className="app-card group w-full md:w-1/2 flex flex-row items-center bg-gradient-to-br from-green-900/20 to-green-800/10 rounded-xl overflow-hidden backdrop-blur-sm border border-green-500/20 transition-all duration-300 hover:border-green-400/40 hover:shadow-lg hover:shadow-green-500/10 hover:-translate-y-1"
            >
              {/* QR Code section */}
              <div className="relative p-3 bg-white/95 rounded-l-xl h-full flex items-center justify-center">
                <img
                  className="w-20 h-20 object-contain"
                  src="image/IOS QR Code 1.svg"
                  alt="Download GBA Taxi Android App"
                />
                <div className="absolute top-2 right-2 w-6 h-6 bg-gray-900 rounded-full flex items-center justify-center">
                  <IoLogoAndroid className="text-green-500 text-xs" />
                </div>
              </div>

              {/* Text content */}
              <div className="flex flex-col p-4">
                <span className="text-xs font-medium text-green-300">
                  GOOGLE PLAY
                </span>
                <span className="text-base font-bold text-white my-1 group-hover:text-green-200 transition-colors">
                  {t("FooterAppDownload4")}
                </span>
                <div className="flex items-center text-xs text-green-400 mt-1">
                  <span>{t("FooterAppDownload5")}</span>
                  <FaChevronRight className="ml-1 text-[8px] transition-transform duration-300 group-hover:translate-x-1" />
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
const LogoSection: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="space-y-6 max-w-md">
      <div className="flex items-center gap-5">
        <div className="bg-gradient-to-br from-white to-gray-200 p-3 rounded-xl shadow-lg">
          <img
            src="/image/logo/GBA_logo.png"
            alt="logo"
            className="w-14 h-14 object-contain"
          />
        </div>
        <div className="flex flex-col ml-2 gap-3">
          <p className="text-lg leading-tight">GBA Taxi</p>
          <p className="text-sm font-medium leading-tight">湾驹出行</p>
        </div>
      </div>

      <div className="mt-6 space-y-4">
        <a
          href="https://wa.link/xzle92"
          className="flex items-center gap-3 p-3 rounded-lg bg-gray-800 hover:bg-gray-700 transition-colors duration-300 group"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaWhatsapp className="text-green-400 text-xl group-hover:scale-110 transition-transform duration-300" />
          <span className="text-gray-300 group-hover:text-white transition-colors">
            <span className="font-medium">{t("FooterInfoTag1")}</span>{" "}
            {t("FooterInfoValue1")}
          </span>
        </a>

        <div className="flex items-center gap-3 p-3 rounded-lg bg-gray-800">
          <FaEnvelope className="text-blue-400 text-xl" />
          <p className="text-gray-300">
            <span className="font-medium">{t("FooterInfoTag2")}</span>{" "}
            {t("FooterInfoValue2")}
          </p>
        </div>

        <div className="flex items-center gap-3 p-3 rounded-lg bg-gray-800">
          <FaMapMarkerAlt className="text-red-400 text-xl" />
          <p className="text-gray-300">
            <span className="font-medium">{t("FooterInfoTag3")}</span>{" "}
            {t("FooterInfoValue3")}
          </p>
        </div>
      </div>
    </div>
  );
};

export const Footer: React.FC<{
  footerRef: React.RefObject<HTMLDivElement>;
}> = ({ footerRef }) => {
  return (
    <footer
      ref={footerRef}
      className="relative  pt-20 pb-10 px-6 overflow-hidden"
    >
      {/* Background decoration elements */}
      {/*<div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500"></div>*/}
      <div className="absolute -top-40 -right-40 w-80 h-80 bg-blue-900 rounded-full opacity-10 blur-3xl"></div>
      <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-purple-900 rounded-full opacity-10 blur-3xl"></div>

      <div className="container mx-auto max-w-7xl relative z-10">
        {/* App Download Section */}
        <div className="mb-16">
          <AppDownloadSection />
        </div>

        {/* Main Footer Content */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
          {/* Logo & Contact Section */}
          <div className="lg:col-span-5">
            <LogoSection />
          </div>

          {/* Links Section */}
          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10">
              <FooterLinkSection
                title="GBA Taxi"
                links={FOOTER_LINKS.GBA_TAXI}
              />
              <FooterLinkSection
                title="Travel Services"
                links={FOOTER_LINKS.TRAVEL_SERVICES}
              />
              {/* Collaborator Section */}
              <CollaboratorSection />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
